import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';

export const checkXpoExport = createProvider(api.checkXpoExport).andCatch((error) => {
  if (error instanceof Error && error.name === 'AbortError') {
    console.warn('Check XPO export aborted');
  } else {
    console.error('Check XPO export was failed:', error);
  }
  throw error;
});
